import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { PreviewPanelProps } from './types';

const styles = cssMap({
	wrapper: {
		height: '100%',
		backgroundColor: token('elevation.surface'),
	},
});

export const PreviewPanel = ({ children, testId }: PreviewPanelProps) => {
	return (
		<Stack xcss={styles.wrapper} testId={testId}>
			{children}
		</Stack>
	);
};
